import React from 'react'
import { useFormContext, RegisterOptions } from 'react-hook-form'
import get from 'lodash/get'
import StyledInput from './StyledInput'

import FieldWrapper, { FieldProps } from './Field'

type Props = FieldProps & {
  type?: string
  rounded?: boolean
  readOnly?: boolean

  /**
   * Options to pass to the react-hook-form register function
   */
  registerOptions?: RegisterOptions

  /**
   * Placeholder
   */
  placeholder?: string
}

const TextField: React.FC<Props> = ({
  type = 'text',
  name,
  label,
  placeholder = '',
  autocomplete,
  rounded = true,
  readOnly,
  registerOptions,
  style,
}) => {
  const {
    formState: { errors },
    register,
  } = useFormContext()
  const error = get(errors, name)

  return (
    <FieldWrapper name={name} label={label}>
      <StyledInput
        {...register(name, registerOptions)}
        id={name}
        name={name}
        placeholder={placeholder}
        type={type}
        error={!!error}
        autoComplete={autocomplete && 'on'}
        rounded={rounded}
        readOnly={readOnly}
        style={style}
      />
    </FieldWrapper>
  )
}

export default TextField
